import { render, staticRenderFns } from "./table-element-action.vue?vue&type=template&id=22e25524&scoped=true&"
import script from "./table-element-action.vue?vue&type=script&lang=js&"
export * from "./table-element-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e25524",
  null
  
)

export default component.exports